export default __webpack_public_path__ + "static/media/test_background.e0f20759.svg";